<template>
  <component :is="component" :n="n" />
</template>

<script>
import { findComponent } from './map'
export default {
  props: {
    n: Object
  },
  computed: {
    component () {
      return findComponent(this.n)
    }
  }
}
</script>